import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabserviceforcorporateemployeespune() {



  const cardData =
  {
    keyword: ' Best Cab Service for Corporate Employees Pune',
    heading: 'Pune Corporate Cars India Private Limited: Best Cab Service for Corporate Employees Pune',
    headingDescription: 'Pune Corporate Cars India Private Limited provides the best cab service for corporate employees in Pune, offering reliable and professional transportation solutions for IT companies, corporate offices, and business parks across the city. Our fleet of premium sedans, SUVs, and executive vehicles ensures comfortable, safe, and punctual travel for employees at all levels. Whether it is daily office commute, airport transfers, inter-office travel, or business meetings, we deliver smooth and hassle-free mobility solutions. With experienced chauffeurs, flexible corporate rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a seamless and premium travel experience for corporate professionals in Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



"services": [
  {
    "name": "Top Corporate Cab Pune",
    "description": "Top Corporate Cab Pune offers premium, safe, and well-managed cab services tailored for companies, IT parks, and corporate offices across Pune. With AC sedans, SUVs, and shuttle vehicles, the service ensures punctual and comfortable employee mobility. Top Corporate Cab Pune is trusted for professional chauffeurs, clean vehicles, and reliable daily commute solutions."
  },
  {
    "name": "Leading Employee Transport Pune",
    "description": "Leading Employee Transport Pune provides structured and dependable transportation for employees working in IT parks, business zones, and industrial areas. With multi-shift support, GPS-enabled vehicles, and trained drivers, the service ensures timely commute and smooth workforce movement across Pune’s major corporate hubs."
  },
  {
    "name": "Premium Office Cabs Pune",
    "description": "Premium Office Cabs Pune delivers high-comfort cab services for office staff, executives, and managers. Featuring AC sedans, executive vehicles, and skilled chauffeurs, the service ensures safe and pleasant daily travel. Premium Office Cabs Pune is ideal for organizations looking for superior-quality office commute solutions."
  },
  {
    "name": "Corporate Mobility Pune",
    "description": "Corporate Mobility Pune offers complete end-to-end mobility solutions including employee commute, executive travel, inter-office transfers, and fleet management. Designed to support corporate operations, the service ensures safety, punctuality, and efficiency for companies across Pune’s IT and industrial sectors."
  },
  {
    "name": "Best Staff Shuttle Pune",
    "description": "Best Staff Shuttle Pune provides large-capacity shuttles for employee group transportation. With AC minibuses, vans, and route-optimized shuttle systems, the service ensures punctual, safe, and cost-effective movement for large teams. Best Staff Shuttle Pune is ideal for IT parks, corporate campuses, and manufacturing units."
  },
  {
    "name": "Business Transport Pune",
    "description": "Business Transport Pune offers versatile travel solutions for business meetings, plant visits, client interactions, and executive mobility. With premium sedans and SUVs operated by trained chauffeurs, the service ensures professional, comfortable, and punctual business travel across and beyond Pune."
  },
  {
    "name": "IT Employee Cab Service Pune",
    "description": "IT Employee Cab Service Pune specializes in transporting IT professionals working in Hinjewadi, Kharadi, Magarpatta, Viman Nagar, and other tech hubs. With verified drivers, night-shift support, GPS tracking, and safe routes, the service ensures smooth daily commute for IT employees across Pune."
  },
  {
    "name": "Reliable Corporate Cabs Pune",
    "description": "Reliable Corporate Cabs Pune provides trustworthy transportation with high service consistency, clean vehicles, and well-trained chauffeurs. Ideal for daily staff movement, executive travel, and intercity corporate trips, the service ensures reliability, comfort, and timely operations throughout Pune."
  },
  {
    "name": "Trusted Fleet Provider Pune",
    "description": "Trusted Fleet Provider Pune offers a robust fleet of sedans, SUVs, shuttles, and tempo travellers for corporate mobility. With complete fleet management, vehicle monitoring, and dedicated support, the service ensures seamless, scalable, and time-efficient transport for companies across Pune."
  },
  {
    "name": "Corporate Chauffeur Service Pune",
    "description": "Corporate Chauffeur Service Pune offers professional chauffeur-driven cars for executives, CEOs, and VIP clients. With luxury sedans, premium SUVs, and trained chauffeurs, the service ensures confidentiality, punctuality, and high-standard executive travel for meetings, airport transfers, and corporate events."
  },
  {
    "name": "Employee Pick Drop Pune",
    "description": "Employee Pick Drop Pune provides systematic and well-coordinated commuting for employees in multiple shifts. Covering residential zones to corporate hubs, the service includes verified drivers, AC vehicles, and punctual daily operations. Employee Pick Drop Pune ensures a smooth, comfortable, and safe commute experience."
  },
  {
    "name": "Best Corporate Fleet Pune",
    "description": "Best Corporate Fleet Pune delivers a comprehensive fleet management system including daily commute vehicles, executive sedans, shuttle vans, and long-term fleet assignments. The service ensures reliable mobility, professional drivers, and optimized routing for businesses of all sizes."
  },
  {
    "name": "Executive Cab Service Pune",
    "description": "Executive Cab Service Pune offers superior-quality sedans and SUVs for managers, directors, and visiting clients. With comfortable interiors, AC atmosphere, and disciplined chauffeurs, the service ensures a refined and smooth corporate travel experience across Pune and nearby cities."
  },
  {
    "name": "Company Travel Cabs Pune",
    "description": "Company Travel Cabs Pune provides versatile transportation solutions for staff commute, intercity visits, executive mobility, and business travel. With reliable scheduling, clean vehicles, and experienced drivers, the service ensures efficient and well-managed travel for corporate teams."
  },
  {
    "name": "Corporate Taxi Provider Pune",
    "description": "Corporate Taxi Provider Pune offers dependable, professionally operated taxis for daily corporate mobility. The service includes a fleet of sedans, SUVs, and shuttle cabs, all maintained for comfort and safety. Corporate Taxi Provider Pune supports employee commute, executive travel, and corporate event transportation."
  }
],
"tableData": [
  ["Top Corporate Cab Pune", "Leading Employee Transport Pune"],
  ["Premium Office Cabs Pune", "Corporate Mobility Pune"],
  ["Best Staff Shuttle Pune", "Business Transport Pune"],
  ["IT Employee Cab Service Pune", "Reliable Corporate Cabs Pune"],
  ["Trusted Fleet Provider Pune", "Corporate Chauffeur Service Pune"],
  ["Employee Pick Drop Pune", "Best Corporate Fleet Pune"],
  ["Executive Cab Service Pune", "Company Travel Cabs Pune"],
  ["Corporate Taxi Provider Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Best Cab Service for Corporate Employees Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers premium and reliable transportation solutions designed specifically for corporate employees across Pune."
  },
  {
    "WhyChooseheading": "Tailored for Corporate Travel Needs",
    "WhyChoosedescription": "Our cab services are customized to support daily employee commute, office travel, and shift-based transportation requirements."
  },
  {
    "WhyChooseheading": "Comfortable & Safe Vehicles",
    "WhyChoosedescription": "We provide fully sanitized, well-maintained, and comfortable vehicles to ensure a smooth and safe travel experience for all employees."
  },
  {
    "WhyChooseheading": "Affordable Corporate Plans",
    "WhyChoosedescription": "We offer cost-effective monthly and long-term corporate cab packages designed to suit the budget of all types of companies."
  },
  {
    "WhyChooseheading": "Punctual & Reliable Service",
    "WhyChoosedescription": "Timely pickup and drop services are ensured to help employees reach the workplace without delays."
  },
  {
    "WhyChooseheading": "Trained & Professional Drivers",
    "WhyChoosedescription": "Our drivers are well-trained, polite, and experienced in handling corporate routes, ensuring a safe and pleasant commute."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "We offer round-the-clock support to handle emergencies, rescheduling, or additional cab requirements."
  },
  {
    "WhyChooseheading": "Easy & Hassle-Free Booking",
    "WhyChoosedescription": "Book corporate cabs quickly through our seamless booking process with guaranteed service reliability."
  }
]

























  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited offer the best cab service for corporate employees in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited is known for providing reliable, safe, and professional cab services specifically designed for corporate employees in Pune.',
  },
  {
    question: 'How can companies book corporate employee cab services in Pune?',
    answer: 'Companies can book through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Do you provide daily office pickup and drop services for corporate employees?',
    answer: 'Yes, we offer structured, timely, and efficient daily pickup and drop services for corporate employees across Pune.',
  },
  {
    question: 'What types of vehicles are available for corporate employee transportation?',
    answer: 'We provide hatchbacks, sedans, SUVs, and tempo travellers based on your team size and transportation needs.',
  },
  {
    question: 'Do you offer monthly and annual plans for corporate employee cab services?',
    answer: 'Yes, we offer flexible monthly and yearly plans tailored for corporate employee transportation.',
  },
  {
    question: 'Are your drivers trained for corporate employee commute requirements?',
    answer: 'Absolutely. Our drivers are trained, courteous, and experienced with corporate commute protocols and shift timings.',
  },
  {
    question: 'Do you offer shift-based cab services for corporate employees?',
    answer: 'Yes, we support all shift timings including early morning, late night, and rotational shifts.',
  },
  {
    question: 'What safety and hygiene measures do you follow for employee cab services?',
    answer: 'We ensure regular vehicle sanitization, safety compliance, GPS tracking, and strict hygiene protocols.',
  },
  {
    question: 'What payment methods are available for corporate employee cab services in Pune?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate billing solutions.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ashish Patil',
    feedback: 'Pune Corporate Cars India Private Limited is the best cab service we have used for our employees. Highly reliable and extremely professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rohini Deshpande',
    feedback: 'Their service quality, punctuality, and driver behavior are excellent. Perfect choice for corporate employee transportation.',
    rating: 5,
  },
];


















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Service for Corporate Employees Pune",
  "image": "https://www.punecorporatecars.com/assets/images/best-corporate-cabs-pune.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited offers the best cab services for corporate employees in Pune, providing premium office cabs, employee pick-up and drop, IT employee transport, and chauffeur-driven corporate fleet services. Reliable, safe, and timely cabs for all corporate travel needs.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "4800", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/best-corporate-cab-service-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>Best Cab Service for Corporate Employees Pune | Premium Employee Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited offers the best cab services for corporate employees in Pune, providing premium office cabs, employee pick-up and drop, IT employee transport, and chauffeur-driven corporate fleet services. Reliable, safe, and timely cabs for all corporate travel needs."
  />

  <meta
    name="keywords"
    content="Top Corporate Cab Pune, Leading Employee Transport Pune, Premium Office Cabs Pune, Corporate Mobility Pune, Best Staff Shuttle Pune, Business Transport Pune, IT Employee Cab Service Pune, Reliable Corporate Cabs Pune, Trusted Fleet Provider Pune, Corporate Chauffeur Service Pune, Employee Pick Drop Pune, Best Corporate Fleet Pune, Executive Cab Service Pune, Company Travel Cabs Pune, Corporate Taxi Provider Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/23.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bestcabserviceforcorporateemployeespune;